module.exports = __webpack_public_path__ + "img/installDesktop2.727bfb12.png";